import React from 'react';
import styled from '@emotion/styled';
import Logo from '../../../components/Header/Logo';

const StyledForm = styled.form`
  flex-grow: 1;
  flex-shrink: 0;
  max-width: 100%;
  input {
    display: block;
    width: 100%;
  }
`;

/**
 * @component for generic auth form
 */

const AuthForm = ({
  children,
  onSubmit,
}: {
  children?: any;
  onSubmit?: any;
}) => {
  return (
    <StyledForm onSubmit={onSubmit} style={{ position: 'relative' }}>
      <Logo showLogotype padding={0} />
      {children}
    </StyledForm>
  );
};

export default AuthForm;
